import LogUtil from './LogUtil';

/**
 * 네이티브 앱(iOS/Android)과 웹뷰 간 통신을 위한 브릿지 클래스
 * CresotyEventBridge를 통해 메시지를 전달합니다.
 */
class NativeBridge {
  private static instance: NativeBridge;
  private bridgeName = 'CresotyEventBridge';

  private constructor() {}

  /**
   * 싱글톤 인스턴스 반환
   */
  static getInstance(): NativeBridge {
    if (!NativeBridge.instance) {
      NativeBridge.instance = new NativeBridge();
    }
    return NativeBridge.instance;
  }

  /**
   * 네이티브 브릿지 사용 가능 여부 확인
   */
  isAvailable(): boolean {
    return !!(
      (window as any)?.webkit?.messageHandlers?.[this.bridgeName] ||
      (window as any)?.[this.bridgeName]?.postMessage
    );
  }

  /**
   * 네이티브로 메시지 전송
   * @param type - 이벤트 타입 (예: 'CameraCancel', 'GoMain', 'AnalysisSuccess')
   * @param data - 전달할 데이터 객체 (선택)
   * @returns 전송 성공 여부
   */
  send(type: string, data?: Record<string, any>): boolean {
    const messageData = {
      resultCode: '200',
      resultMsg: `Event: ${type}`,
      data: {
        type,
        ...(data || {}),
      },
    };

    LogUtil.log('📱 [Native Bridge] Sending message:', messageData);

    try {
      // Flutter webview_flutter 방식 (iOS/Android 공통)
      if ((window as any)?.[this.bridgeName]?.postMessage) {
        LogUtil.log('[Flutter] Sending via', this.bridgeName);
        (window as any)[this.bridgeName].postMessage(
          JSON.stringify(messageData)
        );
        return true;
      }

      // 브릿지가 없는 경우
      LogUtil.warn('⚠️ No native bridge found (Web environment)');
      return false;
    } catch (error) {
      LogUtil.error('❌ Error calling native bridge:', error);
      this.sendError(error as Error);
      return false;
    }
  }

  /**
   * 에러를 네이티브로 전송
   */
  private sendError(error: Error): void {
    const errorData = {
      resultCode: '500',
      resultMsg: error.message || 'Unknown error occurred',
      data: {
        type: 'ERROR',
      },
    };

    try {
      // Flutter webview_flutter 방식 (iOS/Android 공통)
      if ((window as any)?.[this.bridgeName]?.postMessage) {
        (window as any)[this.bridgeName].postMessage(JSON.stringify(errorData));
      }
    } catch (innerError) {
      LogUtil.error('Failed to send error to native:', innerError);
    }
  }
}

export default NativeBridge.getInstance();
